import { GenericTableRow } from "gen/model/genericTableRow";
import { useMemo } from "react";
import { useAgGridEventState } from "shared/components/table/ag/AgGridEventState";
import { useTableBoxContext } from "shared/components/table/box/TableBoxContext";
import { DataTableProps } from "shared/components/table/data/DataTableProps";
import { GenericTableAgGridReactProps } from "shared/components/table/data/DataTableTypes";
import { ROW_ID_PAGINATION } from "shared/components/table/data/internal/DataTableConstants";
import { useMaybernTableUIContext } from "shared/components/table/maybern/MaybernTableUIContext";

export const useDataTablePaginationAgProps = (props: DataTableProps) => {
  const { isFullHeight, isFullScreen } = useTableBoxContext();
  const { agGrid, autoHeightMaxRowCount, autoHeightHiddenRowCount } =
    useMaybernTableUIContext();
  const isPivoting = useAgGridEventState(
    agGrid,
    "columnPivotModeChanged",
    (api) => api.isPivotMode(),
  );
  return useMemo((): GenericTableAgGridReactProps => {
    const shouldPaginate = Boolean(
      !isFullHeight && !isFullScreen && !props.showAllRows,
    );
    const isPaginated =
      shouldPaginate && autoHeightHiddenRowCount > 0 && !isPivoting;

    const paginationRow: GenericTableRow = {
      id: ROW_ID_PAGINATION,
      cells: {},
      granularity_level: "empty",
    };
    if (props.rowDragManaged) return {};

    return {
      // NOTE: This is a workaround for the following issue:
      //
      //   > AG-1282 [React] Make pagination properties reactive
      //   > Until this is implemented, please recreate the grid after changing
      //   > the pagination property values for them to take effect.
      //
      // Re-creating the grid is not practical, so instead we leave pagination
      // always enabled and control the behavior by setting the page size.
      pagination: true,
      paginateChildRows: true,
      paginationPageSize: shouldPaginate
        ? autoHeightMaxRowCount
        : Number.MAX_VALUE,
      pinnedBottomRowData: isPaginated ? [paginationRow] : [],
    };
  }, [
    autoHeightHiddenRowCount,
    autoHeightMaxRowCount,
    isFullHeight,
    isFullScreen,
    isPivoting,
    props.rowDragManaged,
    props.showAllRows,
  ]);
};
